<template lang="pug">
.windows
  window(v-for="t in entries", :title="name(t)", :key="Id(t)", :closeButton="true", :isOpen.sync="t.showParamsWindow")
    ParamsAdjuster(:t="t")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { store } from '../../store';
import { ExternalTileData } from '.';
import ParamsAdjuster from './ParamsAdjuster/index.vue'

@Component({
  components: { ParamsAdjuster },
})
export default class extends Vue {
  get entries() {
    return this.module.entries
  }

  get module() {
    return store.modules.externalTileData
  }

  name(t: ExternalTileData) {
    return t.baseUrl.split('/').slice(-1)[0]
  }
}
</script>


<style lang="scss" scoped>
</style>
